import { ElevationGraphicsModeValue } from '@components/simulation/ElevationGraphicsOption'
import { ElevationGraphicsOptions } from '@mapping/arcgis/models/ElevationGraphicsOptions'
import { ElevationGraphicsParams } from '@mapping/arcgis/models/ElevationGraphicsParams'

export class MapOptions {
  basemap?: number = 0
  isCoastlineVisible?: boolean = true
  isMunicipiosVisible?: boolean
  isHidrografiaVisible?: boolean = true
  isContoursVisible?: boolean = false
  isCarreterasVisible?: boolean = false
  isFerrocarrilVisible?: boolean = false
  isDayNightVisible?: boolean
  isLabelsVisible?: boolean
  isMaskActive?: boolean
  isMapEventsVisible?: boolean = false
  isBurnedAreasVisible?: boolean
  isFuelModelsVisible?: boolean
  isWUIVisible?: boolean
  isTenerifeWildfireOperativityVisible?: boolean
  isMapOverviewVisible?: boolean
  isBrigadasVisible?: boolean
  elevationGraphicsOptions?: ElevationGraphicsOptions
  useDeckGLTransitions?: boolean = false
  opacity: number = 1
  elevation: number = 1
  blur? = 0
  simplify?: boolean

  static defaultMeteoLayers: Partial<MapOptions> = {}

  static defaultMeteoOptions: MapOptions = {
    elevation: 1,
    basemap: 0,
    isDayNightVisible: false,
    isLabelsVisible: true,
    opacity: 0.75,
    blur: 0,
    simplify: false
  }

  static getDefaultMeteoMapOptions() {
    return {
      ...new MapOptions(),
      ...this.defaultMeteoLayers,
      ...this.defaultMeteoOptions
    }
  }

  static defaultFireLayers: Partial<MapOptions> = {
    isBurnedAreasVisible: false
  }

  static defaultFireOptions: MapOptions = {
    basemap: 0,
    elevation: 1,
    isDayNightVisible: false,
    isLabelsVisible: true,
    opacity: 0.75,
    blur: 0,
    simplify: false
  }

  static getDefaultFireMapOptions() {
    return {
      ...new MapOptions(),
      ...this.defaultFireLayers,
      ...this.defaultFireOptions
    }
  }

  static getDefaultSimulationMapOptions(): MapOptions {
    return {
      elevation: 1,
      basemap: 2,
      opacity: 0.5,
      // Is undefined because is pending to be implemented #6317
      isMapOverviewVisible: undefined,
      elevationGraphicsOptions: {
        isElevationGraphicsVisible: true,
        selectedMode: ElevationGraphicsModeValue.CUSTOM,
        parameters: this.getDefaultElevationGraphicsParams()
      }
    }
  }

  static defaultElevationGraphicsParams: ElevationGraphicsParams = {
    opacity: 80,
    elevation: [0, 4000],
    slope: [10, 90],
    aspects: {
      N: false,
      NE: false,
      E: true,
      SE: true,
      S: true,
      SW: true,
      W: true,
      NW: false
    },
    color: { r: 0, g: 229, b: 179 }
  }

  static getDefaultElevationGraphicsParams() {
    return structuredClone(this.defaultElevationGraphicsParams)
  }
}
